export function getCommonProps(props) {
    return {
        elementRef: props.elementRef,
        showPayButton: props.showPayButton,
        isDropin: true
    };
}
